import React from 'react';
import SocialTooltip from '../../social-wallet/tooltip';
import SharedActions from '../sharedActions';

function SingleTeamMember({ member, team }) {
  return (
    <div className="col-lg-4 col-md-6 col-sm-8">
      <div className="third-team-item text-center mb-30">
        <div className="third-team-img">
          <img src={member.image} alt="" />
        </div>
        <div className="third-team-content">
          <div className="main-bg" />
          <div className="hover-bg" />
            <SocialTooltip title={member?.playerAddress}>
              <h5>
                {member.playerAddress?.slice(0, 4)} ...
                {member.playerAddress?.slice(member.playerAddress.length - 3)}
              </h5>
            </SocialTooltip>
            <SharedActions
              openseaLink={`${process.env.REACT_APP_OPENSEA_LINK}/${
                process.env.REACT_APP_SFM_OPENSEA_NETWORK
              }/${member.contractAddress}/${parseInt(member.memberTokenId)}`}
              tweetTitle={`Please join the ${team.name} team`}
              tweetLink={`${window.location.origin}/#/single-team?id=${parseInt(
                team.id
              )}`}
              className={"team-member-actions"}
            />

          <span>Score: {member.score.toString()}</span>
        </div>
      </div>
    </div>
  );
}

export default SingleTeamMember;
